var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page-width"},[_c('datatable',{attrs:{"title":"Stats","response":_vm.data,"fields":_vm.fields,"show_delete":false,"is_createable":false},on:{"edit_click":_vm.edit}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }